import { atomWithStorage } from "jotai/utils";

// TODO: Eventually, when the video ads work smoothly, we should remove this atom or at least make it false by default.
export const disableVideoAdsAtom = atomWithStorage(
  "yallo:disable-video-ads",
  false,
);
